import { useCallback, useEffect } from 'react';
import styles from './styles.module.scss';
import classNames from 'classnames';
import StatusBackgroundLayout from '../../layouts/StatusLayout';
import { DifficultyLevel } from '../../../../shared/enums';
import { setDifficulty } from '../../../game/slice';
import { useAppDispatch } from '../../../../core/redux/hooks/useAppDispatch';
import { useNavigate } from 'react-router-dom';
import { DifficultyGrid } from '../../components/DifficultyGrid';
import DifficultyHeader from '../../components/DifficultyHeader';
import MetroWithPeopleImage from '../../../../assets/images/metro/MetroWithPeople.svg';
import { useGetScoreQuery } from "../../../game/services/GameService";
import { useAppSelector } from '../../../../core/redux/hooks/useAppSelector';
import { selectGameType } from '../../../game/selectors';

const Difficulty = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const gameType = useAppSelector(selectGameType) || '';

  const { refetch: refetchScore, data: scoreData } = useGetScoreQuery(
    { gameCode: gameType },
    {
      skip: !gameType,
      refetchOnMountOrArgChange: false,
      refetchOnReconnect: false,
    },
  );

  useEffect(() => {
    const interval = setInterval(() => {
      refetchScore();
    }, 1000);

    return () => clearInterval(interval);
  }, [refetchScore]);

  const handleSelectLevel = useCallback(
    (level: DifficultyLevel) => {
      dispatch(setDifficulty(level));
      navigate('/metro/game');
    },
    [dispatch, navigate],
  );

  return (
    <div className={classNames(styles.page, 'base-page')}>
      <DifficultyHeader className={styles.header} />

      <StatusBackgroundLayout contentClassName={styles.content}>
        <img alt="" src={MetroWithPeopleImage} className={styles.metroImage} />

        <div className={styles.wrapper}>
          <div className={styles.textContainer}>
            <h1 className={styles.title}>Метро</h1>

            <div className={styles.subTitle}>
              Сосчитай, сколько людей
              <br />
              сейчас находится в метро
            </div>
          </div>

          <DifficultyGrid className={styles.difficultyGrid} opened={scoreData?.goals?.length} onSelectLevel={handleSelectLevel} />
        </div>
      </StatusBackgroundLayout>
    </div>
  );
};

export default Difficulty;
